<template lang='pug'>
  app-layout
    v-flex(xs12)
      v-container.pa-0(fluid)
        create-zipform-transaction(
            ref="zipFormModal"
            closeWhenLogin
            @on-login-success="onLoginSuccess"
            @on-modal-closed="onZipFormClosed"
        )
        connect-cma-modal(
            :value="openConnectModal"
            @save="onConnectCma"
            @close="onCmaClosed"
        )
        connect-transaction-desk(
          :value="openTransactionDeskModal"
          @open="onConnectTransactionDesk"
          @close="onTransactionDeskModalClose"
        )
        v-layout(row wrap)
          iframe(:src="getUrl" @load="fitToContent" ref="iframe")
</template>

<script>
const CreateZipformTransaction = () => 
    import(/* webpackChunkName: 'CreateZipformTransaction' */ '@/Contacts/components/actions/CreateZipformTransaction');

const ConnectCmaModal = () =>
    import(/* webpackChunkName: 'ConnectCmaModal' */ '@/Contacts/components/actions/ConnectCmaModal');

const ConnectTransactionDesk = () =>
    import(/* webpackChunkName: 'ConnectTransactionDesk' */ '@/Contacts/components/actions/ConnectTransactionDesk');

const ANCHOR_ZIPFORM = '#zipForm';
const ANCHOR_CMA = '#cma';
const ANCHOR_TD = '#transactionDesk';

export default {
  name: 'Settings',
  components: {
    CreateZipformTransaction,
    ConnectCmaModal,
    ConnectTransactionDesk,
  },
  data() {
    return {
      openConnectModal: false,
      openTransactionDeskModal: false,
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(newRoute) {
        if (!newRoute && !newRoute.hash.includes([ANCHOR_ZIPFORM, ANCHOR_CMA, ANCHOR_TD])) return;
        this.$nextTick(function() {
          var $this = this;
          setTimeout(function() {
            switch (newRoute.hash) {
              case ANCHOR_ZIPFORM:
                $this.showZipFormModal();
                break;
              case ANCHOR_CMA:
                $this.showCmaModal();
                break;
              case ANCHOR_TD:
                $this.showTransactionDeskModal();
            }
          }, 500);
        })
      }
    },
  },
  methods: {
    fitToContent() {
      this.$refs.iframe.style.height = `${this.$refs.iframe.contentWindow.document.body.scrollHeight}px`;
    },
    showZipFormModal() {
      this.$refs.zipFormModal.open_modal();
    },
    onLoginSuccess() {
      window.location.href = window.location.href.replace(ANCHOR_ZIPFORM,'');
    },
    onZipFormClosed() {
      this.$router.push({ name: 'settings' });
    },
    showCmaModal(){
      this.openConnectModal = true;
    },
    onConnectCma() {
      window.location.href = window.location.href.replace(ANCHOR_CMA,'');
    },
    onCmaClosed(){
      this.openConnectModal = false;
      this.$router.push({ name: 'settings' });
    },
    showTransactionDeskModal() {
      this.openTransactionDeskModal = true;
    },
    onConnectTransactionDesk() {
      window.location.href = window.location.href.replace(ANCHOR_TD,'');
    },
    onTransactionDeskModalClose() {
      this.openTransactionDeskModal = false;
      this.$router.push({ name: 'settings' });
    },
  },
  computed: {
    getUrl() {
      return process.env.VUE_APP_ADMIN_URL + '/settings_v2.html?devNoCache=true';
    }
  },
};
</script>

<style lang="scss" scoped>
  iframe {
    width: 100%;
    border: none;
    min-height: 100vh;
  }
</style>
